export default {
  showActionSheet(state) {
    state.isActionSheetShow = true
  },
  hideActionSheet(state) {
    state.isActionSheetShow = false
  },
  changeView(state, name) {
    state.viewName = name
  },
  setViewNameList(state, name) {
    state.viewName = name
    state.viewNameList.push(name)
  },
  popVieNameList(state) {
    state.viewNameList.pop()
    if (state.viewNameList.length > 0) {
      state.viewName = state.viewNameList[state.viewNameList.length - 1]
    } else {
      state.viewName = ''
    }
  },
  setActionParams(state, params) {
    state.actionParams[state.viewName] = params
  },
  setActionHeader(state, header) {
    state.actionHeader = header
  },
  setArrowState(state, isShow) {
    state.needArrow = isShow
  },
  setPreviewImages(state, images) {
    state.previewImages = images
  },
  setMinprogram(state, data) {
    state.isMinProgram = data
    state.inMinProgram = data
  },
  setChoosedCity(state, data) {
    state.choosedCity = data
  }
}
